<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-head2">FOREWORD</h1>
<p class="FBM-intro">Not long ago, crochet was considered outdated and traditional in a negative sense of the word, between potholders and crochet doilies and, to be honest, it was rarely associated with the self-determined modern image of women.</p>
<p class="FBM-intro">And yet it is just that!</p>
<p class="FBM-intro">Perception has changed and crochet has rediscovered itself, just like all the brave women in this book who impressively demonstrate that it’s possible to break through dusty thought patterns, reinvent yourself and remain true to yourself nevertheless. Modern role models for generations of subsequent women and girls.</p>
<p class="FBM-intro">We owe the concentrated yarn-incarnate emancipation gathered in this book to the wonderful Carla Mitrani, who loves and lives all the contradictions of a modern woman and goes her own way with this fabulous book.</p>
<p class="FBM-intro">Just as Audrey Hepburn said: “Nothing is impossible, the word itself says ‘I’m possible’!”</p>
<p class="FBM-introH"><i>Lydia Tresselt</i></p>
<p class="FBM-introi"><i>Lydia Tresselt is the talented designer behind the Lalylala brand of crochet patterns, and the author of Beetles, Bugs and Butterflies <a href="http://www.lalylala.com" target="_blank">www.lalylala.com</a></i></p>
<p class="image-center"><img alt="" src="images/P7.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Foreword.vue?ba418464